import { Badge, Group, Menu, Stack } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import { Fragment } from 'react';
import RoleSelectorRadioIcon from './RoleSelectorRadioIcon';
import { RoleOption } from './types';
import { ProjectMemberRoleType } from '../../../models/projectRole';

type RoleSelectorItemProps = {
	option: RoleOption;
	isSelected: boolean;
	showDivider?: boolean;
	onChange?: ( role: ProjectMemberRoleType ) => void;
};

const RoleSelectorItem = ( {
	option: { role, disabled, additionalInfo }, isSelected, showDivider, onChange
}: RoleSelectorItemProps ) => (
	<Fragment key={role.id}>
		<Menu.Item
			icon={(
				<RoleSelectorRadioIcon
					label={role.name}
					checked={isSelected}
					disabled={disabled}
				/>
			)}
			color="blue"
			disabled={disabled}
			onClick={() => onChange?.( role.id )}
		>
			<Stack spacing={4}>
				<Group spacing={4} noWrap position="apart">
					<Text variant="footnote-semibold" color={disabled ? 'var(--color-text-light)' : 'var(--color-text-primary)'}>{role.name}</Text>
					{additionalInfo && <Badge color="primary">{additionalInfo}</Badge>}
				</Group>
				<Text variant="caption-regular" color={disabled ? 'var(--color-text-light)' : 'var(--color-text-secondary)'}>{role.description}</Text>
			</Stack>
		</Menu.Item>
		{showDivider && <Menu.Divider />}
	</Fragment>
)

export default RoleSelectorItem;
